import React from "react"

import { Skeleton } from "../Skeleton"

interface ComparisonCardSilhouetteProps {
  rowsCount: number
  horizontal?: boolean
}

const ComparisonCardSilhouette: React.FC<ComparisonCardSilhouetteProps> = ({
  rowsCount,
  horizontal = false,
}) => {
  return (
    <Skeleton className={`w-full ${horizontal ? "flex items-center" : ""} p-5`}>
      {/* Title placeholder */}
      <div className="h-6 rounded-full bg-gray-300 max-w-[200px] mb-4"></div>{" "}
      <div className={`${horizontal ? `grid grid-cols-${rowsCount} gap-6` : ""}`}>
        {Array.from({ length: rowsCount }).map((_, index) => (
          <div key={index} className="grid gap-2">
            {/* Row title placeholder */}
            <div className="h-5 rounded-full bg-gray-300 max-w-[140px]"></div>{" "}
            <div className="flex items-center justify-between gap-2">
              {/* Value placeholder */}
              <div className="h-8 w-32 rounded-full bg-gray-300"></div>
              <div className="flex gap-1 items-center">
                <div className="h-4 w-4 rounded-full bg-gray-300"></div>
                <div className="h-4 w-10 rounded-full bg-gray-300"></div>{" "}
              </div>
            </div>
            {index != rowsCount - 1 && !horizontal && (
              <hr className="w-full border-gray-300 py-1" />
            )}
          </div>
        ))}
      </div>
    </Skeleton>
  )
}

export default ComparisonCardSilhouette
